import script from "./ForgotVerifyMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotVerifyMobile.vue?vue&type=script&setup=true&lang=js"

import "./ForgotVerifyMobile.vue?vue&type=style&index=0&id=57d1b209&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57d1b209"]])

export default __exports__